import { Link, LinkProps } from '../../components/Link/Link'
import { createWidget } from '../widget-utils'

export type LinkWidgetProps = LinkProps & { caption?: string }

export const LinkWidget = ({
  caption,
  children,
  ...props
}: LinkWidgetProps) => {
  return (
    <Link {...props}>
      {caption}
      {children}
    </Link>
  )
}

export const LinkWidgetDefinition = createWidget(LinkWidget, {
  type: 'Link',
})
